<script setup>
import { ref, onMounted } from 'vue';
import Loading from '@/components/common/Loading.vue';
import { useStore } from 'vuex';
import { $api } from '@/services';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import CreateSurvey from './modal/CreateSurvey.vue';
import { useRouter } from 'vue-router';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import UpdateModal from './modal/UpdateModal.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const store = useStore();
const router = useRouter();
const modalIsOpen = ref(false);
const listSurvey = ref([]);
const isLoading = ref(true);
const type = ref('');
const id = ref(null);
const modalType = ref('');
const tabs = ref([
	{
		name: 'Phiếu khảo sát',
	},
	{
		name: 'Biểu mẫu',
	},
]);
const tabAnswer = ref([
	{
		name: 'Biểu mẫu của Luca',
	},
	{
		name: 'Biểu mẫu của trung tâm',
	},
]);
const tab = ref(0);
const tabSelected = ref(0);
const surveyTemplateName = ref('');
const listSurveyTemplateByLuca = ref([]);
const listSurveyTemplateByCenter = ref([]);

onMounted(() => {
	fetchData();
	fetchSurveyTemplate();
	if (route.query.tab === 'template') {
		tabSelected.value = 1;
		const { tab: _tab, tabSelected: _tabSelected, ...query } = route.query;
		router.replace({ path: route.path, query });
	}
	if (route.query.tab === 'template' && route.query.tabSelected === 'center') {
		tabSelected.value = 1;
		tab.value = 1;
		const { tab: _tab, tabSelected: _tabSelected, ...query } = route.query;
		router.replace({ path: route.path, query });
	}
});

const fetchData = async () => {
	try {
		const res = await $api.survey.list();
		listSurvey.value = res.data;
		isLoading.value = false;
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};
const fetchSurveyTemplate = async () => {
	try {
		const res = await $api.survey.listTemplate();
		listSurveyTemplateByLuca.value = res.data.data.filter(
			(item) => item.is_reference
		);
		listSurveyTemplateByCenter.value = res.data.data.filter(
			(item) => !item.is_reference
		);
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};

const redirectToSurveyDetail = (survey) => {
	// if (survey.status === 'draft') {
	// 	router.push(`/survey/create?id=${survey?.id}`);
	// } else {
	router.push(`/survey/${survey?.id}`);
	// }
};

const openInNewTab = (surveyTemplate) => {
	window.open(`/survey/template/${surveyTemplate?.id}`, '_blank');
};

const openCreateModal = () => {
	modalType.value = 'create';
	modalIsOpen.value = true;
};

const openUpdateModal = (val, typeModal) => {
	modalType.value = 'update';
	type.value = typeModal;
	id.value = val.id;
	if (typeModal === 'update' || typeModal === 'duplicate') {
		surveyTemplateName.value = val.name;
	}
	modalIsOpen.value = true;
};
</script>
<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<CreateSurvey
			v-if="modalType === 'create'"
			@close="modalIsOpen = false"
			:listSurveyTemplateByLuca="listSurveyTemplateByLuca"
			:listSurveyTemplateByCenter="listSurveyTemplateByCenter"
		/>
		<UpdateModal
			v-if="modalType === 'update'"
			@close="modalIsOpen = false"
			:id="id"
			:type="type"
			:surveyTemplateName="surveyTemplateName"
			@reloadData="fetchSurveyTemplate"
		/>
	</DaModalFrame>
	<div class="px-12 md-down:px-4 p-10">
		<div
			class="__report-lesson__header pb-10 flex flex-nowrap justify-between items-center"
		>
			<div
				class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl gap-4"
			>
				<img
					class="w-7 h-7"
					src="@/assets/images/icons/survey.png"
					alt=""
				/>
				<div>Phiếu khảo sát</div>
			</div>
			<button
				class="button-p btn--ghost w-fit px-4"
				type="button"
				@click="openCreateModal"
			>
				Tạo khảo sát mới
			</button>
		</div>
		<div class="w-full mb-10">
			<div class="border-b border-neutral-200">
				<nav aria-label="Tabs" class="-mb-px flex space-x-8 tabs">
					<div
						v-for="(t, index) in tabs"
						:key="index"
						:class="
							tabSelected === index
								? 'border-b-2 text-yellow-700 border-yellow-500'
								: 'text-neutral-500'
						"
						class="border-transparent hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"
						@click="tabSelected = index"
					>
						<div class="flex items-center gap-2">
							<div>{{ t.name }}</div>
						</div>
					</div>
				</nav>
			</div>
		</div>
		<div v-if="isLoading" class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
		<div v-else>
			<div
				v-if="
					tabSelected === 1 &&
					(listSurveyTemplateByLuca.length > 0 ||
						listSurveyTemplateByCenter.length > 0)
				"
			>
				<div class="tabs flex mb-10 gap-4">
					<div v-for="(t, index) in tabAnswer" :key="t">
						<div
							:class="{
								'tab-selected': tab === index,
							}"
							class="flex items-center justify-center cursor-pointer py-2 px-3 text-neutral-600"
							@click="tab = index"
						>
							{{ t.name }}
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="
					tabSelected === 1 &&
					(tab === 0
						? listSurveyTemplateByLuca.length > 0
						: listSurveyTemplateByCenter.length > 0)
				"
			>
				<div class="grid grid-cols-3 md-down:grid-cols-1 gap-8">
					<div
						v-for="surveyTemplate in tab === 0
							? listSurveyTemplateByLuca
							: listSurveyTemplateByCenter"
						:key="surveyTemplate.id"
					>
						<div class="bg-white rounded-lg shadow-sm">
							<div
								class="px-6 pt-6 pb-3 cursor-pointer"
								@click="
									router.push(
										`/survey/template/${surveyTemplate?.id}`
									)
								"
							>
								<div class="flex items-start gap-2">
									<img
										v-if="surveyTemplate.is_reference"
										src="@/assets/images/icons/form-fill-yellow.png"
										alt=""
										class="w-5 h-5"
									/>
									<img
										v-else
										src="@/assets/images/icons/form-fill.png"
										alt=""
										class="w-5 h-5"
									/>
									<div
										class="text-neutral-500 text-sm font-semibold"
									>
										{{ surveyTemplate.name }}
									</div>
								</div>
								<div class="text-sm text-neutral-500 mt-3">
									{{ surveyTemplate.question_count }} câu hỏi
								</div>
							</div>
							<div
								class="bg-neutral-50 py-4 px-6 flex items-center justify-between rounded-b-lg"
							>
								<div class="text-sm text-neutral-500">
									Đã dùng {{ surveyTemplate.used_count }} lần
								</div>
								<Menu as="div" class="relative">
									<div>
										<MenuButton
											class="rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
										>
											<span class="sr-only"
												>Open user menu</span
											>
											<svg
												fill="none"
												height="20"
												viewBox="0 0 20 20"
												width="20"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													clip-rule="evenodd"
													d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
													fill="#94A3B8"
													fill-rule="evenodd"
												/>
											</svg>
										</MenuButton>
									</div>
									<transition
										enter-active-class="transition ease-out duration-200"
										enter-from-class="transform opacity-0 scale-95"
										enter-to-class="transform opacity-100 scale-100"
										leave-active-class="transition ease-in duration-75"
										leave-from-class="transform opacity-100 scale-100"
										leave-to-class="transform opacity-0 scale-95"
									>
										<MenuItems
											class="origin-top-right absolute right-0 mt-2 w-60 rounded-md py-1 bg-white focus:outline-none z-10 shadow-sm border border-yellow-100"
										>
											<MenuItem
												v-slot="{ active }"
												@click="
													openInNewTab(surveyTemplate)
												"
											>
												<div
													:class="active ? '' : ''"
													class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
												>
													<img
														src="@/assets/images/icons/link.png"
														alt=""
														class="w-4 h-4"
													/>
													<span
														>Mở trong thẻ mới</span
													>
												</div>
											</MenuItem>
											<MenuItem
												v-if="tab === 1"
												v-slot="{ active }"
												@click="
													openUpdateModal(
														surveyTemplate,
														'duplicate'
													)
												"
											>
												<div
													:class="active ? '' : ''"
													class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
												>
													<img
														src="@/assets/images/icons/copy.png"
														alt=""
														class="w-4 h-4"
													/>
													<span>Tạo bản sao</span>
												</div>
											</MenuItem>
											<MenuItem
												v-if="tab === 1"
												v-slot="{ active }"
												@click="
													openUpdateModal(
														surveyTemplate,
														'update'
													)
												"
											>
												<div
													:class="active ? '' : ''"
													class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
												>
													<img
														src="@/assets/images/icons/pen.png"
														alt=""
														class="w-4 h-4"
													/>
													<span>Đổi tên</span>
												</div>
											</MenuItem>
											<MenuItem
												v-if="tab === 1"
												v-slot="{ active }"
												@click="
													openUpdateModal(
														surveyTemplate,
														'deleteTemplate'
													)
												"
											>
												<div
													:class="active ? '' : ''"
													class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
												>
													<img
														src="@/assets/images/icons/trash.png"
														alt=""
														class="w-4 h-4"
													/>
													<span>Xoá</span>
												</div>
											</MenuItem>
										</MenuItems>
									</transition>
								</Menu>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else-if="tabSelected === 0 && listSurvey.data.length > 0">
				<div class="font-semibold text-lg mb-2">
					Năm {{ listSurvey.year }}
				</div>
				<div class="grid grid-cols-2 md-down:grid-cols-1 gap-2">
					<div
						class="bg-white rounded-lg p-4 shadow-sm flex items-center justify-between"
					>
						<div class="flex items-center gap-2">
							<img
								src="@/assets/images/icons/send-fill.png"
								alt=""
								class="w-5 h-5"
							/>
							<div class="text-neutral-500 text-sm">
								Phiếu khảo sát đã gửi
							</div>
						</div>
						<div class="text-4xl font-bold text-neutral-600">
							{{ listSurvey.stats?.send_count }}
						</div>
					</div>
					<div
						class="bg-white rounded-lg p-4 shadow-sm flex items-center justify-between"
					>
						<div class="flex items-center gap-2">
							<img
								src="@/assets/images/icons/draft.png"
								alt=""
								class="w-5 h-5"
							/>
							<div class="text-neutral-500 text-sm">
								Phiếu khảo sát đang soạn
							</div>
						</div>
						<div class="text-4xl font-bold text-neutral-600">
							{{ listSurvey.stats?.draft_count }}
						</div>
					</div>
				</div>
				<div class="mt-10 w-full">
					<div
						class="shadow sm:rounded-lg overflow-hidden w-full"
					>
						<div class="__record__table w-full overflow-x-auto">
							<table
								class="w-full table-fixed divide-y text-neutral-200"
							>
								<colgroup>
									<col class="w-14" />
									<col />
									<col class="w-28" />
									<col class="w-[18%]" />
									<col class="w-24" />
									<col class="w-24" />
									<col class="w-28" />
								</colgroup>
								<thead class="bg-neutral-100 h-16">
											<tr>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													STT
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													Tiêu đề
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													Trạng thái
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													Đối tượng
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													PH đã xem
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													Hoàn thành
												</th>
												<th
													scope="col"
													class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												>
													ngày gửi
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(
													survey, index
												) in listSurvey.data"
												:key="survey.id"
												:class="
													index % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												"
												class="hover:bg-orange-50 cursor-pointer"
												@click="
													redirectToSurveyDetail(
														survey
													)
												"
											>
												<td
													class="px-6 py-3 whitespace-nowrap text-neutral-700"
												>
													{{ index + 1 }}
												</td>
												<td
													class="px-6 py-3 whitespace-pre-wrap text-neutral-700 break-words min-w-0"
												>
													{{ survey.name }}
												</td>
												<td
													class="px-6 py-3 whitespace-nowrap"
												>
													<div
														class="text-neutral-700"
														v-if="
															survey.status ===
															'draft'
														"
													>
														Bản nháp
													</div>
													<div
														v-else-if="
															survey.status ===
															'closed'
														"
														class="font-semibold text-sienna-500"
													>
														Đã thu hồi
													</div>
													<div
														v-else
														class="font-semibold text-green-500"
													>
														Đã gửi
													</div>
												</td>
												<td
													class="px-6 py-3 text-neutral-700 break-words min-w-0"
													v-if="survey.display_subject"
													v-html="survey.display_subject.replace(/\n/g, '<br/>')"
												></td>
												<td
													v-else
													class="px-6 py-3 whitespace-nowrap text-neutral-700"
												>
													-
												</td>
												<td
													class="px-6 py-3 whitespace-nowrap text-neutral-700 w-max"
												>
													<div
														v-if="
															survey.status ===
															'draft'
														"
													>
														-
													</div>
													<div v-else>
														{{
															survey.total_parent_seen
														}}/{{
															survey.total_parent
														}}
													</div>
												</td>
												<td
													class="px-6 py-3 whitespace-nowrap text-neutral-700 w-max"
												>
													<div
														v-if="
															survey.status ===
															'draft'
														"
													>
														-
													</div>
													<div v-else>
														{{
															survey.total_parent_completed
														}}/{{
															survey.total_parent
														}}
													</div>
												</td>
												<td
													class="px-6 py-3 whitespace-nowrap text-neutral-700 w-max"
												>
													<div
														v-if="
															survey?.inserted_at &&
															survey.status !==
																'draft'
														"
													>
														{{
															$filters.formatDateDDMM(
																survey?.inserted_at
															)
														}}
													</div>
													<div v-else>-</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
			</div>
			<div
				v-else
				class="w-full h-full mt-20 flex items-center justify-center flex-col"
			>
				<img
					src="@/assets/images/illustrations/not_found.png"
					alt=""
					height="250"
					width="250"
				/>
				<div
					class="text-neutral-500 text-lg text-center"
					style="max-width: 700px"
				>
					{{
						tabSelected === 0
							? 'Trung tâm chưa có phiếu khảo sát nào.'
							: 'Trung tâm chưa có biểu mẫu khảo sát nào. Bạn hãy tạo phiếu khảo sát để lưu biểu mẫu của trung tâm.'
					}}
				</div>
				<button
					type="button"
					class="h-12 button-p btn--ghost text-center px-6 whitespace-nowrap mt-4 w-max"
					@click="openCreateModal()"
				>
					Tạo phiếu khảo sát mới
				</button>
			</div>
		</div>
	</div>
</template>
<style scoped>
.menu-action {
	z-index: 100;
	bottom: -25px;
	right: 80px;
	border-radius: 6px;
	border: 1px solid #f9e3b7;
	background: #fff;
	width: 224px;
	box-shadow: 0px 10px 16px 0px rgba(20, 37, 63, 0.06),
		0px 0px 1px 0px rgba(12, 26, 75, 0.1);
}
.tab-selected {
	border-radius: 8px;
	background: #e5a42b;
	box-shadow: 0px 3px 8px -1px #3232470d;
	color: #fff;
}
</style>
